<template>
    <div id="login">

        <div id="login_module" class="col-10 col-sm-4 col-md-4 col-lg-3">
            <img src="https://www.leffix.playworld.nl/themes/assets/playworld/logo_200.png" alt="">
            <h2>INLOGGEN</h2>
            <div id="form">
                <form action="" @submit.prevent="signin()">
                    <div class="form-group">
                        <input type="text" class="form-control" v-model="login.email" placeholder="Emailadres">
                    </div>
                    <div class="form-group">
                        <input type="password" class="form-control" v-model="login.password" placeholder="Wachtwoord">
                    </div>
                    <div class="form-group">
                        <p v-if="login_task.error" class="msg text-danger">{{login_task.error_msg}}</p>
                        <p v-if="login_task.successfull" class="msg text-success">{{login_task.success_msg}}</p>
                        <button :disabled="(login_task.task_loader ? true:false)" class="btn btn-party btn-theme btn-block p-2" type="submit">
                            <div id="task_loader" v-if="login_task.task_loader"></div>
                            {{login_task.btntext}}
                        </button>
                    </div>
                    <a class="mb-3" href="/forgot-password">Wachtwoord vergeten?</a> <br>
                    <br>
                </form>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name:'login',
    data(){
        return {
            login:{
                email:'',
                password:''
            },
            login_task:{
                sent:false,
                error:false,
                error_msg:'',
                success:false,
                success_msg:'',
                btntext:"INLOGGEN",
                task_loader:false
            }
        }
    },
    methods:{
        signin(){
            this.login_task.error=false;

            if(this.login.email.trim().length==0 || this.login.password.trim().length==0){
                this.login_task.error=true;
                this.login_task.error_msg="Vul je gebruikersnaam en wachtwoord in";

                return false;
                
            }

            this.login_task.task_loader=true;
            this.login_task.btntext="Aan het inloggen...";
            
            this.$store.dispatch("post",{endpoint:this.$store.state.endpoint+'login',details:this.login})
            .then(data=>{
                window.console.log(data);
                if(data.data.hasOwnProperty('error')){
                    this.login_task.task_loader=false;
                    this.login_task.error=true;
                    this.login_task.error_msg= data.data.error;
                    this.login_task.btntext="INLOGGEN";

                }else{
                    this.login_task.task_loader=false;
                    this.login_task.btntext="Doorverwijzen...";

                    this.$store.commit('setUser',data.data.user);
                    this.$store.commit('setToken',data.data.token);
                    window.location="/";
                }

            })
            .catch(error=>{
                console.log('error', error.request);
                if(error.request.status == 401){
                    this.login_task.error=true;
                    this.login_task.error_msg="Logingegevens ongeldig";
                }

                // window.console.log(JSON.parse(error.request.response));
                this.login_task.error=true;
                this.login_task.error_msg="error in connectie, probeer opnieuw";

                this.login_task.task_loader=false;
                this.login_task.btntext="INLOGGEN";
            });
        }
    },
    created(){
        var user=JSON.parse(localStorage.getItem('user'));
        var token=JSON.parse(localStorage.getItem('token'));

        if(token != null && user !=null){
            window.location='/';
        }

    }
}
</script>

<style scoped>
    #task_loader{
        width: 20px;
        height: 20px;
        border: 2px solid gray;
        border-top: 2px solid white;
        border-radius: 50%;
        position: absolute;
        left: 15%;
        margin-top: 0.7%;
        animation: spin .6s linear infinite;
    }
     @keyframes spin{
        0%{
            transform: rotate(0deg);
        }
        100%{
            transform: rotate(360deg);
        }
    }
    body{
        background-color:#222 !important;
    }
    #login_module .foot{
        padding: 10px 16px;
    }
    #login_module .foot a{
        font-size: 13px;
        font-weight: bold;
        color: #545454;
    }
    #login_module{
        position: absolute;
        top:0;
        bottom:0;
        left:0;
        right:0;
        margin:auto;
        background: #222;
        display: table;
        border-radius: 5px;
        box-shadow: 0px 0px 3px gray;
    }
    #login_module img{
        width: 265px;
        display: block;
        margin: 0 auto;
        margin-top: -13px;
        background-color: #222;
        border-radius: 7px;
        box-shadow: 0px 0px 2px grey;
        padding: 5px 7px;
    }
    #login_module h2{
        text-align: center;
        margin: 20px 0px;
        color: #faba05;
        font-weight: 700;
    }
    #login_module form{
        text-align: center;
        
    }
    #login_module form input:focus{
        border:1px solid #faba05;
        box-shadow: none;
    }
</style>
